/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Faq from 'bundles/accomplishments/components/shared/Faq';

const styles = {
  container: css`
    width: 100%;
  `,
  list: css`
    list-style: none;
    padding: 0;
  `,
};

type FaqType = {
  question: string;
  answer: string;
};

type PropsFromCaller = {
  faqs: FaqType[];
};

const Faqs = ({ faqs }: PropsFromCaller) => (
  <div className="rc-Faqs" css={styles.container}>
    <ul role="tree" css={styles.list}>
      {faqs.map(({ question, answer }, index) => (
        <Faq key={question} question={question} answer={answer} index={index} />
      ))}
    </ul>
  </div>
);

export default Faqs;
